var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-avatar',_vm._b({staticClass:"justify-center",attrs:{"color":_vm.avatarColor}},'v-list-item-avatar',_vm.avatarOptions,false),[_vm._v("\n  "+_vm._s(_vm.userInitials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }